
import React, { Component } from 'react'
import Header from './components/header'
import Footer from './components/footer'
// import { Link } from 'react-router-dom';
import PageTilte from './components/pageTilte';
// import Sidebar from './components/produce/sidebar';
// import axios from 'axios';
// import { constantApp } from '../../config/constant';
import ConsultComponent from './components/home/consult'


class Consult extends Component {
    // constructor(props) {
    //     super(props);
    // const { match: { params } } = this.props;
    // this.state = {
    //     idProduce: params.id,// this.props.location.state.id,
    //     ProduceName: '',
    //     Brief: '',
    //     Content: '',
    //     isLoading: true,
    //     // isNetworkError: false

    // };
    // }


    componentDidMount = async () => {
        // // const { match: { params } } = this.props;

        // // console.log(params.id)
        // // console.log(this.props.params.id)
        window.scrollTo(0, 0)
        // let url = `${constantApp.SERVERIP}/PHP/Produce/Select_Produce_One.php`;

        // let param = {
        //     idProduce: this.state.idProduce,
        // }
        // let data = await axios.post(url, param)
        //     .then(function (response) {

        //         return response.data;
        //     })
        //     .catch(function (error) {
        //         // this.setState({ isNetworkError: true })
        //     });
        // if (data.length > 0) {
        //     let n = JSON.parse(JSON.stringify(data[0]));
        //     let Content = n["Content"];
        //     let ProduceName = n["ProduceName"];
        //     let Brief = n["Brief"];
        //     this.setState({
        //         ProduceName,
        //         Brief,
        //         Content,
        //         isLoading: false,

        //     })
        // }

    }

    render() {
        return (
            <div >
                <Header />
                <PageTilte title={'درخواست مشاوره'} />

                <ConsultComponent BackgroundVisible={false} />

                <Footer />
            </div>
        );
    }
};



export default Consult; 